import theme from 'src/theme/index';


export const yellowButton = {
    backgroundColor: "#EAB308",
    boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.06), 0px 4px 6px rgba(0, 0, 0, 0.1)',
    borderRadius: '100px',
    color: theme.palette.primary.main,
    fontSize: '14px',
    lineHeight: '17px',
    padding: '12px 32px',
    width: '100%'
}

export const blueButton = {
    backgroundColor: theme.palette.secondaryLight.main,
    boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.06), 0px 4px 6px rgba(0, 0, 0, 0.1)',
    borderRadius: '100px',
    color: "#fff",
    fontSize: '14px',
    lineHeight: '17px',
    padding: '12px 32px',
    width: '100%'
}